export var CommandType;
(function (CommandType) {
    CommandType[CommandType["Unknown"] = 0] = "Unknown";
    CommandType[CommandType["LoadPieceTable"] = 1] = "LoadPieceTable";
    CommandType[CommandType["OpenDocument"] = 2] = "OpenDocument";
    CommandType[CommandType["SaveDocument"] = 3] = "SaveDocument";
    CommandType[CommandType["NewDocument"] = 4] = "NewDocument";
    CommandType[CommandType["SaveAsDocument"] = 5] = "SaveAsDocument";
    CommandType[CommandType["ReloadDocument"] = 6] = "ReloadDocument";
    CommandType[CommandType["StartCommand"] = 7] = "StartCommand";
    CommandType[CommandType["CheckSpelling"] = 8] = "CheckSpelling";
    CommandType[CommandType["AddWordToDictionary"] = 9] = "AddWordToDictionary";
    CommandType[CommandType["GetRtf"] = 10] = "GetRtf";
    CommandType[CommandType["InsertRtf"] = 11] = "InsertRtf";
    CommandType[CommandType["ForceSyncWithServer"] = 12] = "ForceSyncWithServer";
    CommandType[CommandType["InsertContentFromServer"] = 13] = "InsertContentFromServer";
    CommandType[CommandType["DownloadMergedDocument"] = 14] = "DownloadMergedDocument";
    CommandType[CommandType["PdfExported"] = 15] = "PdfExported";
    CommandType[CommandType["DeleteRuns"] = -1] = "DeleteRuns";
    CommandType[CommandType["InsertSimpleRun"] = -2] = "InsertSimpleRun";
    CommandType[CommandType["ChangeCharacterProperty"] = -3] = "ChangeCharacterProperty";
    CommandType[CommandType["ChangeTextBuffer"] = -4] = "ChangeTextBuffer";
    CommandType[CommandType["ApplyCharacterStyle"] = -5] = "ApplyCharacterStyle";
    CommandType[CommandType["ChangeCharacterPropertiesUseValue"] = -6] = "ChangeCharacterPropertiesUseValue";
    CommandType[CommandType["InsertParagraph"] = -7] = "InsertParagraph";
    CommandType[CommandType["MergeParagraphs"] = -8] = "MergeParagraphs";
    CommandType[CommandType["ChangeParagraphProperty"] = -9] = "ChangeParagraphProperty";
    CommandType[CommandType["ApplyParagraphStyle"] = -10] = "ApplyParagraphStyle";
    CommandType[CommandType["ChangeParagraphPropertiesUseValue"] = -11] = "ChangeParagraphPropertiesUseValue";
    CommandType[CommandType["InsertSection"] = -12] = "InsertSection";
    CommandType[CommandType["MergeSections"] = -13] = "MergeSections";
    CommandType[CommandType["ChangeSectionProperties"] = -14] = "ChangeSectionProperties";
    CommandType[CommandType["CreateBookmark"] = -15] = "CreateBookmark";
    CommandType[CommandType["DeleteBookmark"] = -16] = "DeleteBookmark";
    CommandType[CommandType["InsertInlinePicture"] = -17] = "InsertInlinePicture";
    CommandType[CommandType["ChangeInlineObjectProperties"] = -18] = "ChangeInlineObjectProperties";
    CommandType[CommandType["LoadPicturesInfo"] = -19] = "LoadPicturesInfo";
    CommandType[CommandType["UpdateInlinePictures"] = -20] = "UpdateInlinePictures";
    CommandType[CommandType["DelayedPrint"] = -21] = "DelayedPrint";
    CommandType[CommandType["ChangeDefaultTabWidth"] = -22] = "ChangeDefaultTabWidth";
    CommandType[CommandType["ChangePageColor"] = -23] = "ChangePageColor";
    CommandType[CommandType["SaveMergedDocument"] = -24] = "SaveMergedDocument";
    CommandType[CommandType["ChangeDifferentOddAndEvenPages"] = -25] = "ChangeDifferentOddAndEvenPages";
    CommandType[CommandType["ApplyNumberingList"] = -26] = "ApplyNumberingList";
    CommandType[CommandType["AddNumberingList"] = -27] = "AddNumberingList";
    CommandType[CommandType["DeleteNumberingList"] = -28] = "DeleteNumberingList";
    CommandType[CommandType["AddAbstractNumberingList"] = -29] = "AddAbstractNumberingList";
    CommandType[CommandType["DeleteAbstractNumberingList"] = -30] = "DeleteAbstractNumberingList";
    CommandType[CommandType["ChangeListLevelCharacterProperties"] = -31] = "ChangeListLevelCharacterProperties";
    CommandType[CommandType["ChangeListLevelParagraphProperties"] = -32] = "ChangeListLevelParagraphProperties";
    CommandType[CommandType["ChangeListLevelProperties"] = -33] = "ChangeListLevelProperties";
    CommandType[CommandType["ChangeIOverrideListLevel"] = -34] = "ChangeIOverrideListLevel";
    CommandType[CommandType["DeleteTabAtParagraph"] = -35] = "DeleteTabAtParagraph";
    CommandType[CommandType["InsertTabToParagraph"] = -36] = "InsertTabToParagraph";
    CommandType[CommandType["CreateStyleLink"] = -37] = "CreateStyleLink";
    CommandType[CommandType["DeleteStyleLink"] = -38] = "DeleteStyleLink";
    CommandType[CommandType["InsertField"] = -39] = "InsertField";
    CommandType[CommandType["FieldUpdate"] = -40] = "FieldUpdate";
    CommandType[CommandType["HyperlinkInfoChanged"] = -41] = "HyperlinkInfoChanged";
    CommandType[CommandType["DeleteField"] = -42] = "DeleteField";
    CommandType[CommandType["CreateHeader"] = -43] = "CreateHeader";
    CommandType[CommandType["CreateFooter"] = -44] = "CreateFooter";
    CommandType[CommandType["ChangeHeaderIndex"] = -45] = "ChangeHeaderIndex";
    CommandType[CommandType["ChangeFooterIndex"] = -46] = "ChangeFooterIndex";
    CommandType[CommandType["CreateTable"] = -47] = "CreateTable";
    CommandType[CommandType["RemoveTable"] = -48] = "RemoveTable";
    CommandType[CommandType["ShiftTableStartPosition"] = -49] = "ShiftTableStartPosition";
    CommandType[CommandType["ChangeTableCell"] = -50] = "ChangeTableCell";
    CommandType[CommandType["ChangeTableCellProperty"] = -51] = "ChangeTableCellProperty";
    CommandType[CommandType["ChangeTableRow"] = -52] = "ChangeTableRow";
    CommandType[CommandType["ChangeTableRowProperty"] = -53] = "ChangeTableRowProperty";
    CommandType[CommandType["ChangeTable"] = -54] = "ChangeTable";
    CommandType[CommandType["ChangeTableProperty"] = -55] = "ChangeTableProperty";
    CommandType[CommandType["SplitTableCellHorizontally"] = -56] = "SplitTableCellHorizontally";
    CommandType[CommandType["MergeTableCellHorizontally"] = -57] = "MergeTableCellHorizontally";
    CommandType[CommandType["InsertTableRow"] = -58] = "InsertTableRow";
    CommandType[CommandType["RemoveTableRow"] = -59] = "RemoveTableRow";
    CommandType[CommandType["RemoveTableCell"] = -60] = "RemoveTableCell";
    CommandType[CommandType["InsertTableCell"] = -61] = "InsertTableCell";
    CommandType[CommandType["ApplyTableStyle"] = -62] = "ApplyTableStyle";
    CommandType[CommandType["LoadFontInfo"] = -63] = "LoadFontInfo";
    CommandType[CommandType["ChangeCharacterProperties"] = -64] = "ChangeCharacterProperties";
    CommandType[CommandType["ChangeParagraphProperties"] = -65] = "ChangeParagraphProperties";
    CommandType[CommandType["InsertAnchoredPicture"] = -66] = "InsertAnchoredPicture";
    CommandType[CommandType["ChangeAnchorInfoProperty"] = -67] = "ChangeAnchorInfoProperty";
    CommandType[CommandType["ChangeAnchoredObjectShapeProperty"] = -68] = "ChangeAnchoredObjectShapeProperty";
    CommandType[CommandType["ChangeAnchoredPictureSize"] = -69] = "ChangeAnchoredPictureSize";
    CommandType[CommandType["ChangeAnchoredTextBoxSize"] = -70] = "ChangeAnchoredTextBoxSize";
    CommandType[CommandType["InsertAnchoredTextBox"] = -71] = "InsertAnchoredTextBox";
    CommandType[CommandType["ChangeTextBoxProperties"] = -72] = "ChangeTextBoxProperties";
    CommandType[CommandType["RequestModelAfterHibernation"] = -73] = "RequestModelAfterHibernation";
})(CommandType || (CommandType = {}));
